export const itemsToReviewPantoneColorsSelector = state => state.accountOrders.itemsToReviewPantoneColors;
export const isReviewPantonesByCustomerAllowedSelector = (state, props) => true;
export const isReviewMockupsByCustomerAllowedSelector = (state, props) => true;